import { lazy } from "react";

const Base = lazy(() =>
    import("./dialog").then((module) => ({ default: module.Dialog }))
);

const Header = lazy(() =>
    import("./dialog").then((module) => ({ default: module.Dialog.Header }))
);

const Body = lazy(() =>
    import("./dialog").then((module) => ({ default: module.Dialog.Body }))
);

const Footer = lazy(() =>
    import("./dialog").then((module) => ({ default: module.Dialog.Footer }))
);

export const Dialog = Object.assign(Base, {
    Header: Header,
    Body: Body,
    Footer: Footer
});
